function dobbleGameGirl(girl_id,resources,conf) {
    this.girl_id=girl_id;
    var girl_name="pillow";
    var img="girl_enemy";
    if(girl_id!=0){
        girl_name=$.takeGirlImage(girl_id);
        img="girl_own";
    }
    this.ownConf=$.extend(true,{
        onHit:function(){},
        val_max:1,
    },conf);        
    
    var margin=120;
    
    
    var qConf_main={
        custom:{
            x:100,
            "wait":"animation",
            "punch":"animation2",
            "hit":"animation3",
            "put":"animation4",
            "bonus":"animation5",
            attach:[
                [{slot:"kubraczek1",name:"kubraczek1"}],
                [{slot:"kubraczek1",name:"kubraczek2"}],
                [{slot:"kubraczek1",name:"kubraczek3"}],
                []
            ]
        },
        pantress:{x:50},
        sanshi:{x:40},
        geeky:{x:50},
        dora:{x:20},
        emma:{x:-10},
        victoria:{x:40},
        cindy:{x:40},
        indira:{x:30},
        zoe:{x:30},
        twins:{x:-20},
        maggie:{x:30},
        winona:{x:30},
        linn:{x:50},
        alice:{x:50},
        cherry:{
            attach:[
                [{slot:"kubraczek1",name:"kubraczek1"}],
                [{slot:"kubraczek1",name:"kubraczek2"}],
                [{slot:"kubraczek1",name:"kubraczek3"}],
                [{slot:"kubraczek1",name:"kubraczek4"}],
            ]
        },
        ice:{
            attach:[
                [{slot:"kubraczek1",name:"kubraczek1"}],
                [{slot:"kubraczek1",name:"kubraczek2"}],
                [{slot:"kubraczek1",name:"kubraczek3"}],
                [{slot:"kubraczek1",name:"kubraczek4"}],
            ]
        },
        ashley:{
            attach:[
                [{slot:"kubraczek1",name:"kubraczek1"}],
                [{slot:"kubraczek1",name:"kubraczek2"}],
                [{slot:"kubraczek1",name:"kubraczek3"}],
                [{slot:"kubraczek1",name:"kubraczek4"}],
            ]
        },
        anya:{
            attach:[
                [{slot:"kubraczek1",name:"kubraczek1"}],
                [{slot:"kubraczek1",name:"kubraczek2"}],
                [{slot:"kubraczek1",name:"kubraczek3"}],
                [{slot:"kubraczek1",name:"kubraczek4"}],
            ]
        },
        pillow:{
            x:-120,
            attach:[
                [{slot:"kubraczek",name:"kubraczek1"},{slot:"kub1",name:"kub1"},{slot:"kub2",name:"kub2"}],
                [{slot:"kubraczek",name:"kubraczek2"},{slot:"kub1",name:"kub1"},{slot:"kub2",name:"kub2"}],
                [{slot:"kubraczek",name:"kubraczek3"},{slot:"kub1",name:"kub1"},{slot:"kub2",name:"kub2"}],
                [{slot:"kubraczek",name:"kubraczek4"}],
            ]
        }
    };
    
    
    
    if(typeof qConf_main[girl_name]=="undefined"){
        qConf_main[girl_name]={};
    }
    this.girlConf=$.extend(true,{},qConf_main.custom,qConf_main[girl_name]);
    if(typeof qConf_main[girl_name]!="undefined" && typeof qConf_main[girl_name].attach!="undefined"){
        this.girlConf.attach=copyArray(qConf_main[girl_name].attach);
    }
    
    this.force_anim=this.girlConf.wait;
    
    var thc=this;   
    myPixiElement.spine.call(this,{
        img:img,spine_conf:{
            anim_loop:false,
            anim_name:this.girlConf.wait,
            spineResource:resources,
            onAnimComplete:function(){
                thc.playAnim(thc.force_anim);
            }
        }
    });
    this.x=this.girlConf.x;
    
    this.state.addListener({
        event: function(entry, event) { 
            if(event.data.name=="hit"){
                thc.ownConf.onHit.call(thc);
            }
        },
    });
    
};
dobbleGameGirl.prototype = Object.create(myPixiElement.spine.prototype);
dobbleGameGirl.prototype = $.extend(dobbleGameGirl.prototype,{
    qAnim:function(state){
        var name=this.girlConf[state];
        if(name==this.conf.spine_conf.anim_name){
            return false;
        }
        this.playAnim(name);
        if(state=="bonus"){
            this.force_anim=this.girlConf.bonus;
        }
        else if(!in_array(state,["hit"])){
            this.force_anim=this.girlConf.wait;
        }
        
        return true;
    },
    restoreForceAnim:function(){
        this.force_anim=this.girlConf.wait;
    },
    handleAttach:function(val){
        
        var val_max=this.ownConf.val_max;
        val=Math.max(0,val_max-val);
        var att_conf=this.girlConf.attach;
        if(att_conf.length==0){
            return false;
        }
        var val_id=getIdFromRange(val,1,val_max,att_conf.length)-1;
        var i,bum,ready={},k,arr,slot_name;
        for(i=0;i<att_conf.length;i++){
            if(i!=val_id){
                for(k in att_conf[i]){
                    slot_name=att_conf[i][k].slot;
                    ready[slot_name]="hide";
                }
            }
        }
        for(i=0;i<att_conf.length;i++){
            if(i==val_id){
                for(k in att_conf[i]){
                    slot_name=att_conf[i][k].slot;
                    ready[slot_name]=att_conf[i][k].name;
                }
            }
        }
        var bum;
        for(slot_name in ready){
            bum=ready[slot_name];
            if(bum=="hide"){
                this.hideAttachment(slot_name);
            }
            else{
                this.showAttachment(slot_name,bum);
            }
        }
    }
    
});